import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import MyAccountTabs from 'layouts/MyAccountTabs';
import PlanDetailsCard from 'components/PlanDetailsCard';
import { tabItems } from './';
import usePlan from 'hooks/usePlan';
import ProfileService from 'services/ProfileService';
import { getTabItems } from 'utils/myAccount';
import { useAuthUser } from 'features/auth/AuthUserContext';
import { withAuth } from 'features/auth/withAuth';

function Plan() {
  const { user } = useAuthUser();
  const [plan] = usePlan();
  const profileService = new ProfileService();
  const [billingHistory, setBillingHistory] = useState([]);

  async function fetchHistory() {
    try {
      const { data } = await profileService.getBillingHistory(user.id);
      setBillingHistory(data);
    } catch (error) {
      console.log(error.message);
    }
  }

  useEffect(() => {
    fetchHistory();
  }, []);

  return (
    <MyAccountTabs title="My Plan" tabItems={getTabItems(user, billingHistory, tabItems)}>
      <Head>
        <title>Plan and Billing - My Account - Mind The Graph</title>
      </Head>

      <PlanDetailsCard changePlanAction={true} paymentMethodUpdate={true} plan={plan} />
    </MyAccountTabs>
  );
}

export default withAuth(Plan);
